export default __webpack_public_path__ + "739c4e0a3ffb5d1efd0c3d5732f46221.png";